import React from 'react'

export const UserContext = React.createContext();
export const ColorContext = React.createContext();  
export const UserUsername = React.createContext();